import { Injectable } from '@angular/core';
import { CoordinatePoint, CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ProcedureLeg, ProcedureLegModel } from 'src/app/models/procedure-leg';
import { MapService } from 'src/app/services/map.service';
import * as olProj from 'ol/proj';
import { Feature } from 'ol';
import LineString from 'ol/geom/LineString';
import { ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ProcedureModel } from 'src/app/models/procedure';
import VectorSource from 'ol/source/Vector';
import Geometry from 'ol/geom/Geometry';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { CurvePointDTO } from 'src/app/models/curvePointDTO';
import { PointsService } from 'src/app/services/points.service';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { Fill, Stroke, Style } from 'ol/style';
import { AirSpaceBoundaryModel } from 'src/app/models/air-space-boundary';
import { AirSpaceBoundaryVertexLine } from 'src/app/models/AirSpaceBoundaryVertexLine';
import { FeatureType } from 'src/app/models/EnumTypes';
import { AirSpaceBoundaryCoordinatePointModel } from 'src/app/models/air-space-boundary-coordinate-point';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class SelectCoordinatePointsControlService {

  coordinatePointsModal: CoordinatePointModel[] = [];
  airportsCoordinatePoints: CoordinatePointModel[] = [];
  tempProcedureLeg: ProcedureLegModel[];
  selectedProcedure: ProcedureModel;
  selectedAirSpaceBoundary: AirSpaceBoundaryModel;
  selectedProcedureLeg: ProcedureLegModel;
  isStraightlLeg: boolean;
  actualLetId: number;
  activeFixPoint: CoordinatePointModel;
  activeChangeStartPoint: boolean = false;
  activeChangeEndPoint: boolean = false;
  activeChangeAirport: boolean = false;
  activeChangeFixPoint: boolean = false;
  curveSmoothness: number = 0.1;
  radius: number;
  arcLength: number;
  aircraftSpeedValid: boolean = true;
  originalProcedureID: string;
  originalAirSpaceBoundaryID: string;
  isFromAirSpaceBoundary: boolean = false;
  selectedAirport: CoordinatePointModel;
  airSpaceBoundaryActive: boolean = false;
  createProcedureTempID: number;
  constructor(private mapService: MapService,
    private globalSelection: GlobalSelectionControlService,
    private pointsService: PointsService,
    private vicentyService: VicentyToolControlService) {
    this.selectedProcedure = new ProcedureModel();
    this.selectedAirSpaceBoundary = new AirSpaceBoundaryModel();
    this.activeFixPoint = new CoordinatePointModel();
  }


  setValidationValid(value: boolean): void {
    this.aircraftSpeedValid = value;
  }
  isCoordinatePointSelected(coordPoints: ProcedureCoordinatePointModel[]): boolean {
    let toReturn = false;
    coordPoints.forEach(coordPoint => {
      if (coordPoint.coordPoint.isselected) {
        toReturn = true;
      }
    });
    return toReturn;
  }

  isAirSpaceBounderCoordinatePointSelected(coordPoints: AirSpaceBoundaryCoordinatePointModel[]) {
    let toReturn = false;
    coordPoints.forEach(coordPoint => {
      if (coordPoint.coordPoint.isselected) {
        toReturn = true;
      }
    });
    return toReturn;
  }

  selectRow(row: CoordinatePointModel, list: CoordinatePointModel[]): void {
    list.forEach(coord => {
      if (coord.coordpointid == row.coordpointid && coord.name == row.name) {
        coord.isselected = true;
        return;
      }
      coord.isselected = false;
    })
  }

  selectProcedureCoordinatePointRow(row: ProcedureCoordinatePointModel, list: ProcedureCoordinatePointModel[]): void {
    list.forEach(coord => {
      if (coord.coordPoint.id == row.coordPoint.id && coord.coordPoint.name == row.coordPoint.name && coord.coordPoint.latitude ==
        row.coordPoint.latitude && coord.coordPoint.longitude == row.coordPoint.longitude) {
        coord.coordPoint.isselected = true;
        this.pointsService.clearSelectedCoordinatePoints();
        if (!coord.coordPoint.id && !coord.coordPoint.uuid) {
          return;
        }
        this.globalSelection.setSelectedCoordinatePointModel(coord.coordPoint);
        return;
      }
      coord.coordPoint.isselected = false;
    });
  }

  selectProcedureAssessmentCoordinatePointRow(row: ProcedureCoordinatePointModel, list: ProcedureCoordinatePointModel[]): void {
    list.forEach(coord => {
      if (coord.coordPoint.id == row.coordPoint.id && coord.coordPoint.name == row.coordPoint.name && coord.coordPoint.latitude ==
        row.coordPoint.latitude && coord.coordPoint.longitude == row.coordPoint.longitude) {
        coord.coordPoint.isselected = true;
        this.removeAllSelectedCoordinatePoints();
        this.selectCoordinatePoint(coord);
        return;
      }
      coord.coordPoint.isselected = false;
    });

  }

  selectAirSpaceBoundaryCoordinatePointRow(row: AirSpaceBoundaryCoordinatePointModel, list: AirSpaceBoundaryCoordinatePointModel[]): void {
    list.forEach(coord => {
      if (coord.coordPoint.id == row.coordPoint.id && coord.coordPoint.name == row.coordPoint.name && coord.coordPoint.latitude ==
        row.coordPoint.latitude && coord.coordPoint.longitude == row.coordPoint.longitude) {
        coord.coordPoint.isselected = true;
        this.pointsService.clearSelectedCoordinatePoints();
        if (!coord.coordPoint.id) {
          return;
        }
        this.globalSelection.setSelectedCoordinatePointModel(coord.coordPoint);
        return;
      }
      coord.coordPoint.isselected = false;
    });
  }

  selectCoordinatePoint(coordinatePoint: ProcedureCoordinatePointModel): void {
    let layer: VectorLayerDMTR;
    const WaypointVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id === 'waypoint')
      .olLayer;
    const ARPCivilVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_civil')
      .olLayer;
    const ARPMilitaryVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_militar')
      .olLayer;
    const ARPMixedVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_mixed')
      .olLayer;
    const RWY_THRVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'rwy_thr')
      .olLayer;
    const VertexVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'airspace_vertex')
      .olLayer;
    const FixPointVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'fix_point')
      .olLayer;

    if (coordinatePoint.coordPoint.type != undefined) {
      switch (coordinatePoint.coordPoint.type) {
        case 'WAYPOINT':
          layer = WaypointVectorSource;
          break;
        case 'ARP_CIVIL':
          layer = ARPCivilVectorSource;
          break;
        case 'ARP_MILITAR':
          layer = ARPMilitaryVectorSource;
          break;
        case 'RWY_THR':
          layer = RWY_THRVectorSource;
          break;
        case 'AIRSPACE_BOUNDARY_VERTEX':
          layer = VertexVectorSource;
          break;
        case 'ARP_MIXED':
          layer = ARPMixedVectorSource;
          break;
        case 'FIX_POINT':
          layer = FixPointVectorSource;
          break;
        default:
          break;
      }

      const vectorSource = layer.getSource();
      const features = vectorSource.getFeatures();
      const value = coordinatePoint.coordPoint.id == undefined ? coordinatePoint.coordPoint.coordpointid : coordinatePoint.coordPoint.id;
      const property = coordinatePoint.coordPoint.id == undefined ? 'coordpointid' : 'id';
      let found: Feature;
      for (let i = 0, ii = features.length; i < ii; i++) {
        this.globalSelection.removeSelectedFeature(features[i], true);
        if (features[i].get(property) === value) {
          found = features[i];
        }
      }

      if (found != undefined) {
        this.globalSelection.setSelectedFeature(layer, found);
      }
    }
  }


  removeAllSelectedCoordinatePoints(): void {
    const layers: VectorLayerDMTR[] = [];
    const WaypointVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id === 'waypoint')
      .olLayer;
    const ARPCivilVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_civil')
      .olLayer;
    const ARPMilitaryVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_militar')
      .olLayer;
    const ARPMixedVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_mixed')
      .olLayer;
    const RWY_THRVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'rwy_thr')
      .olLayer;
    const VertexVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'airspace_vertex')
      .olLayer;
    const FixPointVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'fix_point')
      .olLayer;


    layers.push(WaypointVectorSource);
    layers.push(ARPCivilVectorSource);
    layers.push(ARPMilitaryVectorSource);
    layers.push(ARPMixedVectorSource);
    layers.push(RWY_THRVectorSource);
    layers.push(VertexVectorSource);
    layers.push(FixPointVectorSource);

    layers.forEach(layer => {
      const features = layer.getSource().getFeatures();
      for (let i = 0, ii = features.length; i < ii; i++) {
        this.globalSelection.removeSelectedFeature(features[i], true);
      }
    });
  }


  selectProcedureLegRow(row: ProcedureLegModel, list: ProcedureLegModel[]) {
    this.activeFixPoint = new CoordinatePointModel();
    this.radius = 0;
    this.arcLength = 0;
    list.forEach(leg => {
      if (leg.procedurelegid == row.procedurelegid) {
        leg.isselected = true;
        this.selectedProcedureLeg = leg;
        if (leg.fixPoint) {
          this.activeFixPoint.latitude = leg.fixPoint.coordPoint.latitude;
          this.activeFixPoint.longitude = leg.fixPoint.coordPoint.longitude;
          this.activeFixPoint.latLonDms.fromLat(leg.fixPoint.coordPoint.latitude);
          this.activeFixPoint.latLonDms.fromLon(leg.fixPoint.coordPoint.longitude);
          this.arcLength = this.mapService.convertMetersToNauticalMiles(this.calculateDistance(leg));
          this.radius = this.mapService.convertMetersToNauticalMiles(VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
            leg.startPoint.coordPoint.longitude, leg.fixPoint.coordPoint.latitude, leg.fixPoint.coordPoint.longitude));
        }
        this.isStraightlLeg = this.getStraightlLeg(leg);
        return;
      }
      leg.isselected = false;
    });
    this.selectLegFeature(row, this.selectedProcedure);
    this.pointsService.clearSelectedCoordinatePoints();
    if (row.fixPoint)
      this.globalSelection.setSelectedCoordinatePointModel(row.fixPoint.coordPoint);
  }

  getStraightlLeg(leg: ProcedureLeg): boolean {
    let toReturn: boolean = leg.isstraightleg;
    this.tempProcedureLeg.forEach(tempLeg => {
      if (tempLeg.procedurelegid == leg.procedurelegid) {
        toReturn = tempLeg.isstraightleg;
      }
    })
    return toReturn;
  }

  getLegId(): string {
    let toReturn: string = '';
    if (this.actualLetId == undefined) {
      this.actualLetId = 1;
      toReturn = "l" + this.actualLetId + "_" + uuidv4();
    } else {
      toReturn = "l" + (this.actualLetId += 1) + "_" + uuidv4();
    }
    return toReturn;
  }

  selectLegFeature(leg: ProcedureLegModel, procedure: ProcedureModel): void {
    let layer: VectorLayerDMTR;
    let sidSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer;
    let enrouteSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer;
    let starSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer;
    let assessmentSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer;

    switch (procedure.proceduretype) {
      case 'SID':
        layer = sidSource;
        break;
      case 'STAR':
        layer = starSource;
        break;
      case 'ENROUTE':
        layer = enrouteSource;
        break;
      case 'ASSESSMENT':
        layer = assessmentSource;
        break;
      default:
        break;
    }
    const vectorSource = layer.getSource();
    const features = vectorSource.getFeatures();
    const value = leg.procedurelegid;
    const property = 'featureId';
    let found: Feature;
    for (let i = 0, ii = features.length; i < ii; i++) {
      this.globalSelection.removeSelectedFeature(features[i]);
      if (features[i].get(property) === value) {
        found = features[i];
      }
    }

    if (found != undefined) {
      this.globalSelection.setSelectedFeature(layer, found);
    }
  }

  removeAllAirSpaceBoundarySelectedLines(airspaceBoundary: AirSpaceBoundaryModel): void {
    let layer: VectorLayerDMTR = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
      .find((element) => element.id === 'Air_Space_Boundary')
      .olLayer

    var vectorSource = layer.getSource();
    var features = vectorSource.getFeatures();

    var found: Feature;
    for (var i = 0, ii = features.length; i < ii; i++) {
      this.globalSelection.removeSelectedFeature(features[i]);
    }
  }

  removeAllSelectedLegs(procedure: ProcedureModel): void {
    let layer: VectorLayerDMTR;
    let sidSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer;
    let enrouteSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer;
    let starSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer;
    let assessmentSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer;

    switch (procedure.proceduretype) {
      case 'SID':
        layer = sidSource;
        break;
      case 'STAR':
        layer = starSource;
        break;
      case 'ENROUTE':
        layer = enrouteSource;
        break;
      case 'ASSESSMENT':
        layer = assessmentSource;
        break;
      default:
        break;
    }
    var vectorSource = layer.getSource();
    var features = vectorSource.getFeatures();

    var found: Feature;
    for (var i = 0, ii = features.length; i < ii; i++) {
      this.globalSelection.removeSelectedFeature(features[i]);
    }
  }

  addLineToMap(line: AirSpaceBoundaryVertexLine, airspaceboundary: AirSpaceBoundaryModel, temp_id?: number): void {
    let points = [];

    //first
    points.push([
      line.startPoint.coordPoint.longitude,
      line.startPoint.coordPoint.latitude,
    ]);
    points.push([
      line.endPoint.coordPoint.longitude,
      line.endPoint.coordPoint.latitude,
    ]);

    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      id: this.selectedAirSpaceBoundary.id ? 'TEMP_AIRSPACE_BOUNDARY_' + this.selectedAirSpaceBoundary.id : 'TEMP_CREATE_AIRSPACE_BOUNDARY_' + temp_id,
      geometry: new LineString(points),
      type: "AIRSPACE_BOUNDARY_VERTEX",
      airspaceboundaryid: this.selectedAirSpaceBoundary.id,
      uniqueId: this.selectedAirSpaceBoundary.uniqueid,
      featureId: line.id,
      changedLeg: true,
      selectedOnManage: false,
      featureType: FeatureType.AirSpaceBoundary
    });

    let source = this.getLayerSourceFromAirSpaceBoundaryType(airspaceboundary);
    source.addFeature(feat);

    line.sequencenumber = line.sequencenumber != undefined ? line.sequencenumber : this.actualLetId;
  }

  deleteTempLegOnMap(leg: ProcedureLegModel): void {
    let source = this.getLayerSourceFromProcedureType(this.selectedProcedure.proceduretype)

    source.getFeatures().forEach(feat => {
      if (feat.getProperties().featureId == leg.procedurelegid
        && this.selectedProcedure.procedureid == feat.getProperties().procedureid
        && feat.getProperties().tempLegArray) {
        source.removeFeature(feat);
      }
    });
  }

  deleteProcedureLegsOnMap(procedure: ProcedureModel): void {
    let source = this.getLayerSourceFromProcedureType(procedure.proceduretype)
    for (const leg of procedure.procedureLegs) {
      const featureToRemove = source.getFeatures().find((feat) => feat.getProperties().featureId == leg.procedurelegid
        && procedure.procedureid == feat.getProperties().procedureid);
      if (featureToRemove != null) {
        source.removeFeature(featureToRemove);
      }
    }
    // source.getFeatures().forEach( feat =>{
    //   if(feat.getProperties().featureId == leg.procedurelegid
    //     && this.selectedProcedure.procedureid == feat.getProperties().procedureid){
    //     source.removeFeature(feat);
    //   }
    // });
  }

  addLegToMap(leg: ProcedureLegModel, procedure: ProcedureModel, tempLegArray?: boolean, tempID?: number): void {
    let points = [];

    //first
    points.push([
      leg.startPoint.coordPoint.longitude,
      leg.startPoint.coordPoint.latitude,
    ]);
    if (!leg.isstraightleg) {
      leg.curvePoints.forEach(curvePoint => {
        points.push([curvePoint.longitude, curvePoint.latitude]);
      });
    }
    points.push([
      leg.endPoint.coordPoint.longitude,
      leg.endPoint.coordPoint.latitude,
    ]);

    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      id: procedure.id ? 'TEMP_PROCEDURE_' + procedure.id : 'TEMP_CREATE_PROCEDURE_' + tempID,
      geometry: new LineString(points),
      type: procedure.proceduretype,
      procedureid: procedure.procedureid,
      featureId: leg.procedurelegid,
      changedLeg: true,
      selectedOnManage: false,
      featureType: 2, //procedure
      sequencenumber: leg.sequencenumber,
      tempLegArray: tempLegArray,

    });

    /*var style100 = new Style({
      stroke: new Stroke({
          color: "#ff0000",
          width: 5,
      }),
      fill : new Fill({
          color: "#ff0000",
      }),
      zIndex:100
  });

    feat.setStyle(style100);*/

    let source = this.getLayerSourceFromProcedureType(procedure.proceduretype);
    source.addFeature(feat);

    leg.sequencenumber = leg.sequencenumber != undefined ? leg.sequencenumber : this.actualLetId;
  }

  getLayerSourceFromAirSpaceBoundaryType(airspaceboundary: AirSpaceBoundaryModel): VectorSource {
    return this.pointsService.airspaceboundariesLayers.childLayers[0].layers
      .find((element) => element.id === 'Air_Space_Boundary')
      .olLayer.getSource();
  }

  getLayerSourceFromProcedureType(procedureType: String): VectorSource {
    let sidSource = this.globalSelection.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer.getSource();
    let enrouteSource = this.globalSelection.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer.getSource();
    let starSource = this.globalSelection.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer.getSource();

    let assessmentSource = this.globalSelection.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();

    let assessmentOffsetSource = this.globalSelection.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();

    let source;
    switch (procedureType) {
      case 'SID':
        source = sidSource;
        break;
      case 'STAR':
        source = starSource;
        break;
      case 'ENROUTE':
        source = enrouteSource;
        break;
      case 'ASSESSMENT':
        source = assessmentSource;
        break;
      case 'ASSESSMENToffset':
        source = assessmentOffsetSource;
        break;
      default:
        break;
    }

    return source;
  }

  transformCoordinatePointToProcedureCoodinatePoint(coordPoint: CoordinatePointModel): ProcedureCoordinatePointModel {
    let toReturn: ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
    toReturn.id = coordPoint.id;
    toReturn.coordPoint = coordPoint;
    toReturn.procedurecoordpointtype = coordPoint.type;
    return toReturn;
  }

  calculateCurvePoints(leg: ProcedureLeg): ProcedureCoordinatePointModel[] {

    let toReturn: ProcedureCoordinatePointModel[] = [];
    let i: number = 0;


    let radius: number = VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude, leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude);
    let startAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude, leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude);
    let endAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude, leg.endPoint.coordPoint.latitude,
      leg.endPoint.coordPoint.longitude);

    let angle: number = startAzimuth - endAzimuth;
    if (angle > 0.0) {
      if (angle > 180.0) {
        for (let t = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
          / 10.0; t = ((t + this.curveSmoothness) % 360.0 + 360.0) % 360.0) {
          toReturn.push(this.calculatePoint(VicentyToolControlService, i, t, radius, leg));
        }
      } else {
        for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
          / 10.0; t = ((t - this.curveSmoothness) % 360.0 + 360.0) % 360.0) {
          toReturn.push(this.calculatePoint(VicentyToolControlService, i, t, radius, leg));
        }
      }
    } else {
      angle = Math.abs(angle);
      if (angle > 180.0) {
        for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
          / 10.0; t = ((t - this.curveSmoothness) % 360.0 + 360.0) % 360.0) {
          toReturn.push(this.calculatePoint(VicentyToolControlService, i, t, radius, leg));
        }
      } else {
        for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
          / 10.0; t = ((t + this.curveSmoothness) % 360.0 + 360.0) % 360.0) {
          toReturn.push(this.calculatePoint(VicentyToolControlService, i, t, radius, leg));
        }
      }
    }
    return toReturn;
  }

  calculatePoint(tool: VicentyToolControlService, i: number, t: number, radius: number, leg: ProcedureLegModel): ProcedureCoordinatePointModel {
    let calculatedPoint: number[] = VicentyToolControlService.calculateDestinationPoint(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude, t, radius);
    let newPoint: ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
    newPoint.altitude = leg.startPoint.altitude;
    let point: CoordinatePointModel = new CoordinatePointModel();
    let curvePoint: CurvePointDTO = new CurvePointDTO();
    curvePoint.latitude = calculatedPoint[0];
    curvePoint.longitude = calculatedPoint[1];
    point.latitude = calculatedPoint[0];
    point.longitude = calculatedPoint[1];
    point.coordpointid = (leg.id + "CP" + i);
    newPoint.coordPoint = point;
    newPoint.isCurvePoint = true;
    leg.curvePoints.push(curvePoint);
    i++;
    return newPoint;
  }

  calculateDistance(leg: ProcedureLeg): number {
    let distance: number = 0;

    if (leg.isstraightleg) {
      distance += VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
        leg.startPoint.coordPoint.longitude, leg.endPoint.coordPoint.latitude,
        leg.endPoint.coordPoint.longitude);
    } else {

      if (leg.curvePoints == null || leg.curvePoints.length < 1) {
        this.calculateCurvePoints(leg);
      }

      let previousLat: number = leg.startPoint.coordPoint.latitude;
      let previousLong: number = leg.startPoint.coordPoint.longitude;

      leg.curvePoints.forEach(point => {
        distance += VicentyToolControlService.calculateDistance(previousLat, previousLong, point.latitude,
          point.longitude);
        previousLat = point.latitude;
        previousLong = point.longitude;
      });
    }
    return distance;
  }



  createLegsFromProcedureCoordinatePoints(proc: ProcedureModel, legsWithFixPoint: ProcedureLegModel[], tempProcedureLegs?: ProcedureLegModel[], temp_id?: number) {
    let sortedCoordPoints: ProcedureCoordinatePointModel[] = proc.procedureCoordinatePoints.sort((a, b) => (a.sequencenumber > b.sequencenumber) ? 1 : ((b.sequencenumber > a.sequencenumber) ? -1 : 0));
    for (let i = 0; i < sortedCoordPoints.length; i++) {
      if (i == 0) {
        let leg: ProcedureLegModel = new ProcedureLegModel();
        leg.startPoint = sortedCoordPoints[i];
        leg.sequencenumber = proc.procedureLegs.length + 1;
        let legId: number = proc.procedureLegs.length + 1;
        leg.procedurelegid = "l" + legId + "_" +uuidv4();

        proc.procedureLegs.push(leg);
      } else if (i == sortedCoordPoints.length - 1) {
        proc.procedureLegs[proc.procedureLegs.length - 1].endPoint = sortedCoordPoints[i];
      } else {
        let leg: ProcedureLegModel = new ProcedureLegModel();
        leg.startPoint = sortedCoordPoints[i];
        proc.procedureLegs[proc.procedureLegs.length - 1].endPoint = sortedCoordPoints[i];
        leg.sequencenumber = proc.procedureLegs.length + 1;
        let legId: number = proc.procedureLegs.length + 1;
        leg.procedurelegid = "l" + legId + "_" + uuidv4();

        proc.procedureLegs.push(leg);
      }

    }

    for (const leg of proc.procedureLegs) {
      let legFixPoint = legsWithFixPoint.find(legWithFixPoint => legWithFixPoint.procedurelegid == leg.procedurelegid)
      if (!legFixPoint ) {
        legFixPoint = legsWithFixPoint.find(legWithFixPoint => legWithFixPoint.startPoint.procedureCoordPointPk == leg.startPoint.procedureCoordPointPk
        && legWithFixPoint.endPoint.procedureCoordPointPk == leg.endPoint.procedureCoordPointPk);
      }
      if (legFixPoint != null) {
        //leg = cloneDeep(legFixPoint);
        leg.isstraightleg = false;
        leg.fixPoint = legFixPoint.fixPoint;
        leg.fixPointId = legFixPoint.fixPointId;
        leg.curvePoints = [];
        this.calculateCurvePoints(leg);
      }

    }
    if (tempProcedureLegs) {
      for (const tempLeg of tempProcedureLegs) {
        tempLeg.startPoint = sortedCoordPoints[tempLeg.startPoint.sequencenumber];
        tempLeg.endPoint = sortedCoordPoints[tempLeg.endPoint.sequencenumber];
        if (tempLeg.fixPoint != null && !tempLeg.isstraightleg) {
          tempLeg.curvePoints = [];
          this.calculateCurvePoints(tempLeg);
        }
        if (this.isTempLegOnMap(tempLeg, proc)) {
          this.deleteTempLegOnMap(tempLeg);
          this.addLegToMap(tempLeg, proc, true, temp_id);
        }

        // mantain modified state
        const leg = proc.procedureLegs.find(leg => leg.startPoint == tempLeg.startPoint && leg.endPoint == tempLeg.endPoint);
        if (leg != null) {
          leg.ismodified = true;
        }

      }
    }


    proc.procedureLegs.forEach(leg => {
      //this.deleteLegOnMap(leg);
      this.addLegToMap(leg, proc, false, temp_id);
      //this.selectCoordinatePointService.selectLegFeature(leg, proc);
    })
  }

  getLegsWithFixPoint(procedure: ProcedureModel) {
    const legsWithFixPoint = [];
    for (const leg of procedure.procedureLegs) {
      if (!leg.isstraightleg && leg.fixPoint != null) {
        legsWithFixPoint.push(leg);
      }
    }
    return legsWithFixPoint;
  }

  isTempLegOnMap(leg: ProcedureLegModel, procedure: ProcedureModel): boolean {
    let source = this.getLayerSourceFromProcedureType(procedure.proceduretype);
    let toReturn = false;
    source.getFeatures().forEach(feat => {
      if (procedure.procedureid == feat.getProperties().procedureid && leg.procedurelegid == feat.getProperties().featureId && feat.getProperties().tempLegArray) {
        toReturn = true;
      }
    });
    return toReturn;
  }

}
